<template>
	<div id="header">
	      <div class="seconedWidth">
			<div id="nav">
				<ul>
					<li>
						<img class="header-logo" src="../../assets/img/index/logo.png" alt="">
						<span>斗牛财经</span>
					</li>
					<li>
						<router-link :to="'/'" :class="{active:selectId==1,hover:hoverId==1}" @mouseover="selectStyle(1)" @mouseout="outStyle()">首页</router-link>
					</li>
					<!-- <li>
						<router-link :to="'/bullStrategy'" :class="{active:selectId==2,hover:hoverId==2}" @mouseover="selectStyle(2)" @mouseout="outStyle()">牛策略</router-link>
					</li>
					<li>
						<router-link :to="'/bullClass'" :class="{active:selectId==3,hover:hoverId==3}" @mouseover="selectStyle(3)" @mouseout="outStyle()">牛人课</router-link>
					</li> -->
					<li>
						<router-link :to="'/downloadApp'" :class="{active:selectId==4,hover:hoverId==4}" @mouseover="selectStyle(4)" @mouseout="outStyle()">下载APP</router-link>
					</li>
					<li>
						<router-link :to="'/recharge'" :class="{active:selectId==5,hover:hoverId==5}" @mouseover="selectStyle(5)" @mouseout="outStyle()">充值</router-link>
					</li>
					<li class="before_login" style="float:right" v-if="!userInfo">
						<div class="denglu">
							
							<div class="show_01" style="display: inline-block;">
								<a class="zhuce" style="color: #000000;" @click="login()">登录</a>
								<span class="shuxian"></span>
								<a class="zhuce" style="color: #000000;" @click="register()">注册</a>
							</div>
						</div>
					</li>
					<li class="after_login" style="float:right" v-if="userInfo">
						<el-dropdown @command="afterLoginHandle" @visible-change="getUserCenter()">
						  <span class="el-dropdown-link">
						    {{userInfo.udNickname}}
							<i class="el-icon-arrow-down el-icon--right"></i>
						  </span>
						  <el-dropdown-menu slot="dropdown">
						    <el-dropdown-item divided command="wallet">
								<div class="wallet">
									<div class="wallet-title">我的牛币</div>
									<div class="wallet-balance">
										<span class="balance-text">账户余额：{{ userBalance }}</span>
									</div>
								</div>
							</el-dropdown-item>
						    <el-dropdown-item divided command="subscribe">我的订阅</el-dropdown-item>
						    <el-dropdown-item divided command="login_out">退出</el-dropdown-item>
						  </el-dropdown-menu>
						</el-dropdown>
					</li>
				</ul>
			</div>
	      </div>
	      <!-- 密码登录弹出框 -->
	      <el-dialog 
		  :visible.sync="dialogVisible" 
		  width="400px" 
		  style="border-radius:10px" 
		  class="login-dialog edit-diog" 
		  :close-on-click-modal="false"
		  @open="dialogCheckCodeImgOpen"
		  @close="loginDialogClose"
		  >
				<template slot="title">
					<div style="font-size: 20px;font-weight: bold;padding-top:20px">
						账号登录
					</div>
					<div class="zhuce" @click="fastLogin()" style="display: block;float: right;margin-top: -15px;font-size:12px;color:red">
						手机快捷登录  
					</div>
				</template>
				<el-form :model="numberValidateForm" ref="numberValidateForm" label-width="100px" class="demo-ruleForm" @keyup.enter.native="openTextVerifyCodeDialog(2)">
				  <el-form-item
					prop="phone"
					:rules="[
					  { required: true, message: '手机号不能为空'},
					  { validator: validator.checkPhone }
					]"
				  >
					<el-input class="numberInput" style="margin-left:-20%;width:120%" type="phone" placeholder="请输入手机号" v-model="numberValidateForm.phone" maxlength="11" autocomplete="off">
						
					</el-input>
					<img class="img1" src="../../assets/img/phone.png" alt="">
				  </el-form-item>
				  <el-form-item
					prop="password"
					:rules="[
					  { required: true, message: '密码不能为空'}
					]"
				  >
					<el-input class="numberInput" style="margin-left:-20%;width:120%" type="password" placeholder="请输入密码" v-model="numberValidateForm.password" autocomplete="off"></el-input>
					<img class="img1" src="../../assets/img/password.png" alt="">
				  </el-form-item>
				  <!-- <el-form-item
					prop="verify_code"
					:rules="[
					  { required: true, message: '验证码不能为空'}
					]"
				  >
					<el-input class="numberInput" style="margin-left:-20%;width:69%" type="ruels" placeholder="请输入验证码" v-model="numberValidateForm.verify_code" autocomplete="off"></el-input>
					<el-button  type="danger" style="margin-left:20px" v-if="verifyCodeBtn == false" @click="openTextVerifyCodeDialog(2)">{{contentTwo}}</el-button>
					<el-button  type="danger" style="margin-left:20px" v-if="verifyCodeBtn == true">{{contentTwo}}</el-button>
					<img class="img1" src="../../assets/img/code.png" alt="">
				  </el-form-item> -->
				  <el-form-item>
					<!-- <el-button style="width:100%;margin-left: -50px;" type="danger" @click="submitForm('numberValidateForm')">登录</el-button> -->
					<el-button style="width:119%;margin-left: -50px;" type="danger" @click="openTextVerifyCodeDialog(2)">登录</el-button>
				  </el-form-item>
					<div class="footer" style="display: inline-block;">
						<a class="zhuce" style="color: red;" @click="forgetPwd()">忘记密码</a>
						<a class="zhuce" style="color: red;margin-left:20px" @click="register()">注册</a>
					</div>
				</el-form>
		</el-dialog>
		<!-- 忘记密码弹出框 -->
		<!-- <el-dialog 
		:visible.sync="forgetDialog" 
		:close-on-click-modal="false"
		width="400px" class="forgetPwd-dialog edit-diog">
		  <template slot="title">
			  <div style="font-size: 20px;font-weight: bold;padding-top:20px">
				  忘记密码
			  </div>
		  </template>
		  <div v-if="ifShow==1">
			  <img class="step1" src="../../assets/img/first-step.jpg" alt="">
		  </div>
		  <div v-if="ifShow==2">
			  <img class="step1" src="../../assets/img/second-step.jpg" alt="">
		  </div>
		  <div v-if="ifShow==3">
			  <img class="step1" src="../../assets/img/three-step.jpg" alt="">
		  </div>
		  <div style="margin-top: 30px;" v-if="ifShow==3">
			  <img class="step2" src="../../assets/img/success.png" alt="">
		  </div>
		  <el-form  :model="forgetForm" ref="forgetForm" label-width="100px" class="demo-ruleForm">
		  <el-form-item v-if="ifShow==1"
			prop="phone"
			:rules="[
			  { required: true, message: '手机号不能为空'},
			  { validator: validator.checkPhone }
			]"
		  >
			<el-input class="numberInput"  style="margin-left:-20%;width:120%" type="phone" placeholder="请输入手机号" v-model="forgetForm.phone" maxlength="11" autocomplete="off">
				
			</el-input>
			<img class="img1" src="../../assets/img/phone.png" alt="">
		  </el-form-item>
		  <el-form-item v-if="ifShow==1"
			prop="verify_code"
			:rules="[
			  { required: true, message: '验证码不能为空'}
			]"
		  >
			<el-input class="numberInput" style="margin-left:-20%;width:69%" type="ruels" placeholder="请输入验证码" v-model="forgetForm.verify_code" autocomplete="off"></el-input>
			<img class="img1" src="../../assets/img/code.png" alt="">
			<el-button  type="danger" style="margin-left:20px" v-if="verifyCodeBtn == false" @click="countDown">{{content}}</el-button>
			<el-button  type="danger" style="margin-left:20px;background-color: darkgray;" v-if="verifyCodeBtn == true">{{contentTwo}}</el-button>
		  </el-form-item>
		  <el-form-item v-if="ifShow==2"
			prop="password"
			:rules="[
			  { required: true, message: '密码不能为空'}
			]"
		  >
			<el-input class="numberInput" style="margin-left:-20%;width:120%" type="password" placeholder="请输入密码" v-model="forgetForm.password" autocomplete="off"></el-input>
			<img class="img1" src="../../assets/img/password.png" alt="">
		  </el-form-item>
		  <el-form-item v-if="ifShow==2"
			prop="sure_password"
			:rules="[
			  { required: true, message: '密码不能为空'}
			]"
		  >
			<el-input class="numberInput" style="margin-left:-20%;width:120%" type="password" placeholder="请确认密码" v-model="forgetForm.sure_password" autocomplete="off"></el-input>
			<img class="img1" src="../../assets/img/password.png" alt="">
		  </el-form-item>
		  <el-form-item>
			<el-button v-if="ifShow==1" style="width:119%;margin-left: -50px;" type="danger" @click="nextForm('forgetForm')">下一步</el-button>
			<el-button v-if="ifShow==2" style="width:119%;margin-left: -50px;" type="danger" @click="nextFormTwo('forgetForm')">下一步</el-button>
			<el-button v-if="ifShow==3" style="width:119%;margin-left: -50px;" type="danger" @click="forgetDialog = false">完成</el-button>
		  </el-form-item>
		</el-form>
		</el-dialog> -->
		
		<el-dialog
		:visible.sync="forgetDialog" 
		:close-on-click-modal="false"
		width="400px" class="forget-pwd-dialog edit-diog">
		  <template slot="title">
			  <div style="font-size: 20px;font-weight: bold;padding-top:20px">
				  忘记密码
			  </div>
		  </template>
		  
		  <el-form  :model="forgetForm" ref="forgetForm" label-width="100px" class="demo-ruleForm">
		  <el-form-item
			prop="phone"
			:rules="[
			  { required: true, message: '手机号不能为空'},
			  { validator: validator.checkPhone }
			]"
		  >
			<el-input class="numberInput"  style="margin-left:-20%;width:120%" type="phone" placeholder="请输入手机号" v-model="forgetForm.phone" maxlength="11" autocomplete="off"></el-input>
			<img class="img1" src="../../assets/img/phone.png" alt="">
		  </el-form-item>
		  <el-form-item
			prop="verify_code"
			:rules="[
			  { required: true, message: '验证码不能为空'}
			]"
		  >
			<el-input class="numberInput" style="margin-left:-20%;width:69%" type="ruels" placeholder="请输入验证码" v-model="forgetForm.verify_code" autocomplete="off"></el-input>
			<img class="img1" src="../../assets/img/code.png" alt="">
			<el-button  type="danger" style="margin-left:20px" v-if="verifyCodeBtn == false" @click="countDown">{{content}}</el-button>
			<el-button  type="danger" style="margin-left:20px;background-color: darkgray;" v-if="verifyCodeBtn == true">{{contentTwo}}</el-button>
		  </el-form-item>
		  <el-form-item
			prop="password"
			:rules="[
			  { required: true, message: '密码不能为空'}
			]"
		  >
			<el-input class="numberInput" style="margin-left:-20%;width:120%" type="password" placeholder="请输入密码" v-model="forgetForm.password" autocomplete="off"></el-input>
			<img class="img1" src="../../assets/img/password.png" alt="">
		  </el-form-item>
		  <el-form-item
			prop="sure_password"
			:rules="[
			  { required: true, message: '密码不能为空'}
			]"
		  >
			<el-input class="numberInput" style="margin-left:-20%;width:120%" type="password" placeholder="请确认密码" v-model="forgetForm.sure_password" autocomplete="off"></el-input>
			<img class="img1" src="../../assets/img/password.png" alt="">
		  </el-form-item>
		  <el-form-item>
			<el-button style="width:119%;margin-left: -50px;" type="danger" @click="nextFormTwo('forgetForm')">确认提交</el-button>
		  </el-form-item>
		</el-form>
		</el-dialog>
		
		<!-- 注册弹出框 -->
		<el-dialog 
		:visible.sync="registerDialog" 
		:close-on-click-modal="false"
		width="400px" 
		class="register-dialog edit-diog" 
		@open="registerDialogOpen"
		@close="registerDialogClose"
		>
		  <template slot="title">
			  <div style="font-size: 20px;font-weight: bold;padding-top:20px">
				  账号注册
			  </div>
		  </template>
		  
		  <el-form  :model="registerForm" ref="registerForm" label-width="100px" class="demo-ruleForm">
		  <el-form-item
			prop="phone"
			:rules="[
			  { required: true, message: '手机号不能为空'},
			  { validator: validator.checkPhone }
			]"
		  >
			<el-input class="numberInput"  style="margin-left:-20%;width:120%" type="phone" placeholder="请输入手机号" v-model="registerForm.phone" maxlength="11" autocomplete="off">
				
			</el-input>
			<img class="img1" src="../../assets/img/phone.png" alt="">
		  </el-form-item>
		  
		  <el-form-item
			prop="password"
			:rules="[
			  { required: true, message: '密码不能为空'}
			]"
		  >
			<el-input class="numberInput" style="margin-left:-20%;width:120%" type="password" placeholder="请输入密码" v-model="registerForm.password" autocomplete="off"></el-input>
			<img class="img1" src="../../assets/img/password.png" alt="">
		  </el-form-item>
		  <el-form-item
			prop="sure_password"
			:rules="[
			  { required: true, message: '密码不能为空'}
			]"
		  >
			<el-input class="numberInput" style="margin-left:-20%;width:120%" type="password" placeholder="请确认密码" v-model="registerForm.sure_password" autocomplete="off"></el-input>
			<img class="img1" src="../../assets/img/password.png" alt="">
		  </el-form-item>
		  <el-form-item
			prop="verify_code"
			:rules="[
			  { required: true, message: '验证码不能为空'}
			]"
		  >
			<el-input class="numberInput" style="margin-left:-20%;width:69%" type="ruels" placeholder="请输入验证码" v-model="registerForm.verify_code" autocomplete="off"></el-input>
			<img class="img1" src="../../assets/img/code.png" alt="">
			<el-button  type="danger" style="margin-left:20px" v-if="verifyCodeBtn == false" @click="openTextVerifyCodeDialog(0)">{{contentTwo}}</el-button>
			<el-button  type="danger" style="margin-left:20px;background-color: darkgray;" v-if="verifyCodeBtn == true">{{contentTwo}}</el-button>
		  </el-form-item>
		  <el-form-item
			:rules="[
			  { required: true, message: '密码不能为空'}
			]"
		  >
			<el-input class="numberInput" style="margin-left:-20%;width:120%" type="ruels" placeholder="注册邀请码（选填）" v-model="registerForm.invitation" autocomplete="off"></el-input>
			<img class="img1" src="../../assets/img/ma.png" alt="">
		  </el-form-item>
		  <el-form-item>
			<el-button  style="width:119%;margin-left: -50px;" type="danger" @click="registerButton('registerForm')">注册</el-button>
		  </el-form-item>
		  <el-form-item>
			<span style="margin-left: -55px;font-size: 12px;">
				<span>
					<input type="radio" name="registerAgreement" :checked="registerForm.agree" @click="agreeRegisterAgreement()">
				</span>
				<span>
					同意并接受
					<a href="javascript:;" style="color: #666666;text-decoration: none;" @click="registerAgreementDialog = true;">《用户协议》</a>
				</span>
			</span>
			  
			<span style="margin-left: 55px;font-size: 12px;">
				<span>已有账户?</span>
				<span>
					<a href="javascript:;" style="color: #C60B09;text-decoration: none;" @click="login()">马上登录</a>
				</span>
			</span>
		  </el-form-item>
		</el-form>
		</el-dialog>
		
		<!-- 快捷登录 -->
		<el-dialog 
		:visible.sync="fastLoginDialog" 
		:close-on-click-modal="false"
		width="400px" 
		class="fastlogin-dialog edit-diog">
			<template slot="title">
				  <div style="font-size: 20px;font-weight: bold;padding-top:20px">
					  手机号快捷登录
				  </div>
				  <div class="zhuce" @click="login()" style="display: block;float: right;margin-top: -15px;font-size:12px;color:red">
				  	  账号登录 
				  </div>
			  </template>
			  
			  <el-form  :model="fastLoginForm" ref="fastLoginForm" label-width="100px" class="demo-ruleForm">
			  <el-form-item
				prop="phone"
				:rules="[
				  { required: true, message: '手机号不能为空'},
				  { validator: validator.checkPhone }
				]"
			  >
				<el-input class="numberInput"  style="margin-left:-20%;width:120%" type="phone" placeholder="请输入手机号" v-model="fastLoginForm.phone" maxlength="11" autocomplete="off">
					
				</el-input>
				<img class="img1" src="../../assets/img/phone.png" alt="">
			  </el-form-item>
			  
			  <el-form-item
				prop="verify_code"
				:rules="[
				  { required: true, message: '验证码不能为空'}
				]"
			  >
				<el-input class="numberInput" style="margin-left:-20%;width:69%" type="ruels" placeholder="请输入验证码" v-model="fastLoginForm.verify_code" autocomplete="off"></el-input>
				<img class="img1" src="../../assets/img/code.png" alt="">
				<el-button  type="danger" style="margin-left:20px" v-if="verifyCodeBtn == false" @click="fastLoginGetCode()">{{contentTwo}}</el-button>
				<el-button  type="danger" style="margin-left:20px;background-color: darkgray;" v-if="verifyCodeBtn == true">{{contentTwo}}</el-button>
			  </el-form-item>
			  <el-form-item>
				<el-button  style="width:119%;margin-left: -50px;" type="danger" @click="fastLoginButton('fastLoginForm')">登录</el-button>
			  </el-form-item>
			  <div class="footer" style="display: inline-block;">
			  	<a class="zhuce" style="color: red;" @click="forgetPwd()">忘记密码</a>
			  	
			  	<a class="zhuce" style="color: red;margin-left:20px" @click="register()">注册</a>
			  </div>
			</el-form>
		</el-dialog>
		<!-- 文字验证码 -->
		<el-dialog width="30%"
		:visible.sync="textVerifyCodeDialog" 
		:close-on-click-modal="false"
		@open="textVerifyCodeDialogOpen"
		@close="textVerifyCodeDialogClose">
			<el-form>
				<el-form-item class="login-input" style="border-bottom: 0px" label="请完成安全验证" prop="code" >
					<div style="padding-bottom: 15px;">
					  <img :src="textVerifyCode.bufferImage" style="width: 100%;" @click="getImgCode" />
					</div>
				
					<div v-if="textVerifyCode.checkSuccess==0" class="unselect" style="position: relative;border: 1px solid #e4e7eb;margin: 0;padding: 0;text-align: center;color: #45494c;box-sizing: border-box;">
					  <span style="vertical-align: middle;text-align: center;color: #45494c;">请依次点击  {{textVerifyCode.imageText}}</span>
					</div>
					<div v-if="textVerifyCode.checkSuccess == 1" class="unselect" style="position: relative;border: 1px solid #e4e7eb;margin: 0;padding: 0;text-align: center;color: #45494c;box-sizing: border-box;color: #52ccba;border-color: #52ccba;background-color: #d2f4ef;">
					  <span class="checkSuccessItem" style="display:inline-block;"></span>
					  <span style="vertical-align: middle;text-align: center;color: #52ccba;">验证成功</span>
					</div>
				
					<div v-if="textVerifyCode.checkSuccess == 0" class="refreshItem" @click="getCheckCodeImg"></div>
				
					<div class="point-1" :style="'left: '+textVerifyCode.point1.x+'px;top:'+textVerifyCode.point1.y+'px;'" v-if="textVerifyCode.point1.isShow == '1'"></div>
					<div class="point-2" :style="'left: '+textVerifyCode.point2.x+'px;top:'+textVerifyCode.point2.y+'px;'" v-if="textVerifyCode.point2.isShow == '1'"></div>
					<div class="point-3" :style="'left: '+textVerifyCode.point3.x+'px;top:'+textVerifyCode.point3.y+'px;'" v-if="textVerifyCode.point3.isShow == '1'"></div>
				
				
				</el-form-item>
			</el-form>
		</el-dialog>
		
		<!-- 身份认证 -->
		<el-dialog 
		:visible.sync="identityCheckDialog"
		:close-on-click-modal="false"
		>
			<v-identityCheck ref="identity"></v-identityCheck>
		</el-dialog>
		<!-- 注册用户协议 -->
		<el-dialog 
		:visible.sync="registerAgreementDialog"
		:close-on-click-modal="false">
			<div v-html="registerAgreement"></div>
		</el-dialog>
	  </div>
</template>

<script>

import identity from '../user/identityCheck'

export default {
	name:'v-header',
	components:{
		'v-identityCheck': identity
	},
	data(){
		return{
			selectId:this.selectedItemVal,
			hoverId:0,
			ifShow:1,
			//用户余额
			userBalance:0,
			dialogVisible:false,
			forgetDialog:false,
			registerDialog:false,
			fastLoginDialog:false,
			identityCheckDialog:false,
			verifyCodeBtn:false,
			//登录用户信息
			userInfo:JSON.parse(localStorage.getItem('user')),
			
			userCenter:'',
			registerAgreementDialog:false,
			registerAgreement:'',
			//文字验证码dialog显示
			textVerifyCodeDialog:false,
			textVerifyCode:{
				point1:{
				  isShow: 0,
				  x: 0,
				  y: 0,
				  clickX:0,
				  clickY:0
				},
				point2:{
				  isShow: 0,
				  x: 0,
				  y: 0,
				  clickX:0,
				  clickY:0
				},
				point3:{
				  isShow: 0,
				  x: 0,
				  y: 0,
				  clickX:0,
				  clickY:0
				},
				imageKey:'',
				imageText:'',
				pointClickTimes: 1,
				bufferImage: "",
				checkSuccess: 0,
				loginTemp:"",
			},
			//登录表单
			numberValidateForm: {
			  phone: '',
			  password:'',
			  verify_code:'',
			  requestId:'',
			},
			forgetForm:{
				phone:'',
				password:'',
				verify_code:'',
				sure_password:'',
			},
			registerForm:{
				phone:'',
				verify_code:'',
				password:'',
				sure_password:'',
				invitation:'',
				agree:false,
			},
			fastLoginForm:{
				phone:'',
				verify_code:''
			},
			content:'获取验证码',
			contentTwo:'获取验证码',
			phoneCodeType:0,
			totalTime:60,
			totalTimeTwo:60,
			canClickTwo: true,
			canClick: true ,//添加canClick
		}
	},
	props:{
		//当前页菜单背景色
		selectedItemVal: {
		  type: Number,
		  required: true,
		  default: false
		},
	},
	//监听加载完成
	mounted() {
		
	},
	watch:{
		userInfo:"userInfoChange"
	},
	methods:{
		//鼠标划入
		selectStyle(item){
			this.hoverId=item;
		},
		//鼠标滑出
		outStyle(){
			this.hoverId=0
		},
		//登录框显示
		login(){
			this.dialogVisible = true;
			this.fastLoginDialog = false;
			this.registerDialog = false;
			this.numberValidateForm = {
				phone:'',
				password:'',
			};
		},
		//快捷登录框显示
		fastLogin(){
			 this.dialogVisible = false;
			 this.fastLoginDialog = true;
			 this.fastLoginForm = {
				 phone:'',
				 password:'',
			 };
		},
		//忘记密码框显示
		forgetPwd(){
			this.forgetDialog=true;
			this.dialogVisible=false;
			this.fastLoginDialog = false;
			this.ifShow=1;
			this.forgetForm={
				phone:'',
				verify_code:'',
				password:'',
				sure_password:'',
			}
		},
		//注册框显示
		register(){
			this.registerDialog=true;
			this.dialogVisible=false;
			this.fastLoginDialog = false;
			this.registerForm={
				phone:'',
				verify_code:'',
				password:'',
				sure_password:'',
				invitation:'',
				agree:false,
			}
		},
		//文字验证码显示
		openTextVerifyCodeDialog(operationType){
			let canOpen = true;
			if(operationType == 0){
				//+----------------注册操作-------------------
				if(!this.registerForm.phone){
					this.$message.error('手机号不能为空');
					canOpen = false;
					return false;
				}
				if(!this.registerForm.password){
					this.$message.error('密码不能为空');
					canOpen = false;
					return false;
				}
				if(this.registerForm.password != this.registerForm.sure_password){
					this.$message.error('两次密码不一致，请重新输入');
					canOpen = false;
					return false;
				}
			}else if(operationType == 2){
				//+-----------------登录操作------------------
				this.$refs['numberValidateForm'].validate((valid) => {
					if(!valid){
						canOpen = false;
						return false;
					}
				});
			}
			
			if(canOpen == true){
				//打开dialog对话框
				this.textVerifyCodeDialog = true;
				//更新操作类型
				//0:代表注册 1：代表忘记 2：手机号验证码登陆 3: 游客登录绑定手机号 4用户注销
				this.phoneCodeType = operationType;
			}
		},
		//身份认证框显示
		identityCheckShow(){
			this.identifyCheckDialog = true;
		},
		agreeRegisterAgreement(){
			this.registerForm.agree = !this.registerForm.agree;
		},
		//请求登录
		submitForm(formName) {
			this.$refs[formName].validate((valid) => {
			  if (valid) {
				  //+-------------------构建请求参数---------------------
				  let data = {
					  phone:this.numberValidateForm.phone,
					  password:this.md5(this.md5(this.numberValidateForm.password)),
					  code:this.numberValidateForm.verify_code,
					  requestId:this.numberValidateForm.requestId
				  };
				  //+-------------------请求登录-------------------------
				  this.apiServer.login.loginByPwd(this.qs.stringify(data))
				  .then(res => {
					  if(res.data.code == 200){
						  if(res.data.data.businessCode != 10){
							this.$message(res.data.data.businessMessage);
							this.getCheckCodeImg();
							return false;
						  }
						  
						  //登录成功【保存用户信息】
						  this.saveUserInfo(res);
						  //用户已登录显示
						  this.userInfo = JSON.parse(localStorage.getItem('user'));
						  //【给出成功提示】
						  this.$message.success('登录成功');
						  //【关闭登录dialog】
						  this.dialogVisible = false;
						  //跳转地址存在
						  if(this.$route.query.redirect){
							  this.$router.push({path:this.$route.query.redirect});
						  }
					  }else{
						  this.$message.error(res.message);
					  }
				  })
				  .catch(res => {
					  this.$message.error('登录失败,请检查账户密码是否正确');
					  this.getCheckCodeImg();
				  });
			  } else {
				console.log('error submit!!');
				return false;
			  }
			});
		},
		//账密登录dialog打开事件
		dialogCheckCodeImgOpen(){
			//+-------------------账密登录对话框打开，获取图片验证码----------
			this.getCheckCodeImg();
		},
		//账密登录dialog关闭事件
		loginDialogClose(){
			let routeQuery = this.$route.query;
			if(routeQuery.auth == 0){
				this.$router.go(-1);
			}
		},
		//监听注册dialog打开
		registerDialogOpen(){
			//+-------------------注册对话框打开，获取图片验证码-------------
			this.getCheckCodeImg();
			
			//+---------------------------获取注册用户协议------------------
			this.apiServer.login.getRegPro()
			.then(res => {
				if(res.data.code == 200){
					if(res.data.data.businessCode != 10){
						this.$message.error('用户注册协议获取异常');
						return false;
					}
					
					this.registerAgreement = res.data.data.proInfo;
				}
			})
			.catch(error => {
				console.log(error);
			});
		},
		//监听注册dialog关闭
		registerDialogClose(){
			
		},
		//文字验证码dialog打开事件
		textVerifyCodeDialogOpen(){
			
		},
		//文字验证码dialog关闭事件
		textVerifyCodeDialogClose(){
			//刷新文字验证码
			this.getCheckCodeImg();
		},
		//请求快捷登录
		fastLoginButton(formName) {
		  	this.$refs[formName].validate((valid) => {
		  	  if (valid) {
				  //+--------------------验证-----------------
				  
		  		  //+-------------------请求登录--------------
		  		  var fastLoginRes = this.registerAndLogin(this.fastLoginForm,'登录成功');
				  if(fastLoginRes) this.fastLoginDialog=false;
		  	  }else{
		  		console.log('error submit!!');
		  		return false;
		  	  }
		  	});
		},
		//请求注册
		registerButton(formName) {
			this.$refs[formName].validate((valid) => {
				if(valid) {
					//验证数据
					if(this.registerForm.password != this.registerForm.sure_password){
						this.$message.error('两次密码不一致，请重新输入');
						return false;
					}
					
					if(!this.registerForm.agree){
						this.$message.error('请您阅读并同意用户协议后操作');
						return false;
					}
					
					//+-------------------请求注册--------------------
					var registerRes = this.registerByApp(this.registerForm,'注册成功');
					if(registerRes) this.registerDialog=false;
				}else {
					console.log('error submit!!');
					return false;
				}
			});
		}, 
		//忘记密码第一个下一步
		nextForm(formName){
			this.$refs[formName].validate((valid) => {
			  if (valid) {
				if(this.forgetForm.phone == ''){
					this.$message.error('手机号不能为空');
					return false;
				}
				var phoneReg = /^[1][3|5|6|7|8|9][0-9]{9}$/;
				if (!phoneReg.test(this.forgetForm.phone)) {
					 this.$message.error("您输入的手机号格式不正确");
					 return false;
				}
				//+------------------------构建请求参数--------------------
				let data = {
					phone:this.forgetForm.phone,
					smsCode:this.forgetForm.verify_code,
				};
				//+------------------请求验证码是否匹配正确-----------------
				this.apiServer.login.phoneCodeCheck(this.qs.stringify(data))
				.then(res => {
					// console.log('忘记密码验证',res.data);
					if(res.data.code == 200){
						this.ifShow=2;
					}
				})
				.catch(error => {
					// console.log('忘记密码验证',error)
					this.$message.error(error);
					return false;
				});
			  } else {
				console.log('error submit!!');
				return false;
			  }
			});
		},
		//忘记密码第二个下一步(重置密码)
		nextFormTwo(formName){
			this.$refs[formName].validate((valid) => {
				if (valid) {
					if(this.forgetForm.password != this.forgetForm.sure_password){
						this.$message.error('两次密码不一致，请重新输入');
						return false;
					}
					
					//+-----------------构建请求参数--------------------
					let data = {
						phone:this.forgetForm.phone,
						vcode:this.forgetForm.verify_code,
						pwd:this.md5(this.md5(this.forgetForm.password))
					};
					//+-----------------重置密码请求--------------------
					this.apiServer.login.forgetPwd(this.qs.stringify(data))
					.then(res => {
						if(res.data.code == 200){
							if(res.data.data.businessCode != 10){
								this.$message.error(res.data.data.businessMessage);
								return false;
							}
							
							//修改成功，展示第三步
							this.ifShow=3;
							
							this.$message({
								type:'success',
								message:res.data.data.businessMessage,
								duration:800,
								onClose:() => {
									this.forgetDialog = false;
								}
							})
						}
					})
					.catch(res => {
						this.$message.error('重置密码异常');
					});
					
				}else{
					console.log('error submit!!');
					return false;
				}
			});
		},
		//获取验证码
		countDown () {
			if(this.forgetForm.phone == ''){
				this.$message.error('手机号不能为空');
				return false;
			}
			var phoneReg = /^[1][3|5|6|7|8|9][0-9]{9}$/;
			if (!phoneReg.test(this.forgetForm.phone)) {
				 this.$message.error("您输入的手机号格式不正确");
				 return false;
			}
			//+-----------------构建请求参数-----------------
			var phone = this.forgetForm.phone;
			var type = 1;
			//+------------------发送验证码------------------
			this.getPhoneCode(phone,type);
		},
		//注册验证码
		countDownTwo(){
			if (!this.canClickTwo) return  //改动的是这两行代码
			 //+----------------构建获取注册验证码参数----------------
			 var phone = this.registerForm.phone;
			 var type = 0;
			 //+--------------------获取注册验证码--------------------
			 this.getPhoneCode(phone,type); 
		},
		//获取验证码
		fastLoginGetCode() {
			if (!this.canClick) return  //改动的是这两行代码
			
			if(!this.fastLoginForm.phone){
				this.$message.error('手机号不能为空');return false;
			}
			
			//+--------------构建参数----------------------
			var phone = this.fastLoginForm.phone;
			var type = 2;
			//+-------------发送验证码---------------------
			this.getPhoneCode(phone,type);
		},
		//获取图片验证码
		getCheckCodeImg(){
			this.textVerifyCode.loginTemp = "";
			this.textVerifyCode.point1={
			  isShow: 0,
				x: 0,
				y: 0,
				clickX:0,
				clickY:0
			};
			this.textVerifyCode.point2={
			  isShow: 0,
				x: 0,
				y: 0,
				clickX:0,
				clickY:0
			};
			this.textVerifyCode.point3={
			  isShow: 0,
				x: 0,
				y: 0,
				clickX:0,
				clickY:0
			};
			this.textVerifyCode.pointClickTimes= 1;
			this.textVerifyCode.imageKey= "";
			this.textVerifyCode.imageText= "";
			this.textVerifyCode.checkSuccess= 0;

			this.apiServer.login.getCheckImgCode()
			.then(res => {
			   var tempImg = new Image();
			   tempImg.src='data:image/gif;base64,'+res.data.data.bufferedImage;
			   tempImg.onload=()=>{
					this.textVerifyCode.bufferImage = 'data:image/gif;base64,'+res.data.data.bufferedImage;
			   }
				this.textVerifyCode.imageKey = res.data.data.key;

				var temp = "";
				for(var i = 0;i<res.data.data.list.length;i++){
				  temp += (" \""+res.data.data.list[i]+"\" " );
				}
				this.textVerifyCode.imageText = temp;
			});
		},
		// 图片验证码
		getImgCode(e) {
			var rect = e.target.getBoundingClientRect();
	
			var ratio = e.target.width / 750;
	
			if(this.textVerifyCode.pointClickTimes == 1){
			  this.textVerifyCode.point1.x = e.offsetX - 13;
			  this.textVerifyCode.point1.y = e.offsetY - 33;
			  this.textVerifyCode.point1.isShow = 1;
			  this.textVerifyCode.pointClickTimes ++;
	
			  this.textVerifyCode.point1.clickX = e.offsetX / ratio;
			  this.textVerifyCode.point1.clickY = e.offsetY / ratio;
	
			}else if(this.textVerifyCode.pointClickTimes == 2){
			  this.textVerifyCode.point2.x = e.offsetX - 13;
			  this.textVerifyCode.point2.y = e.offsetY - 33;
			  this.textVerifyCode.point2.isShow = 1;
			  this.textVerifyCode.pointClickTimes ++;
	
			  this.textVerifyCode.point2.clickX = e.offsetX / ratio;
			  this.textVerifyCode.point2.clickY = e.offsetY / ratio;
	
			}else if(this.textVerifyCode.pointClickTimes == 3) {
			  this.textVerifyCode.point3.x = e.offsetX - 13;
			  this.textVerifyCode.point3.y = e.offsetY - 33;
			  this.textVerifyCode.point3.isShow = 1;
			  this.textVerifyCode.pointClickTimes++;
	
			  this.textVerifyCode.point3.clickX = e.offsetX / ratio;
			  this.textVerifyCode.point3.clickY = e.offsetY / ratio;
	
			  var pointList = new Array();
			  pointList[0] = this.textVerifyCode.point1.clickX + "," + this.textVerifyCode.point1.clickY;
			  pointList[1] = this.textVerifyCode.point2.clickX + "," + this.textVerifyCode.point2.clickY;
			  pointList[2] = this.textVerifyCode.point3.clickX + "," + this.textVerifyCode.point3.clickY;
	
			  this.textVerifyCode.loginTemp = pointList[0] + "|" + pointList[1] + "|" + pointList[2];
			  var tempData = {
				key: this.textVerifyCode.imageKey,
				list: pointList,
				type: "1"
			  };
			  //+------------------请求文字验证码校验接口-----------------------
			  this.apiServer.login.checkImgCode(tempData)
				.then(res => {
					if(res.data.code != 200){
						this.$message.error(res.data.message);
						return false;
					}
					
					//显示校验成功提示
					this.textVerifyCode.checkSuccess = 1;
					//定时关闭文字验证码dialog
					this.textVerifyCodeDialog = false;
					
					//注册操作获取手机验证码
					if(this.phoneCodeType == 0){
						this.getPhoneCode(this.registerForm.phone,0);
					}
					if(this.phoneCodeType == 2){
						//更新登录表单
						this.numberValidateForm.verify_code = tempData.list.join('|');
						this.numberValidateForm.requestId = tempData.key;
						
						//如果输入了账号密码，自动执行登录
						this.submitForm('numberValidateForm');
					}
				})
				.catch(err => {
					this.getCheckCodeImg();
				});
			}
		},
		//获取短信验证码
		getPhoneCode(phone,type){
			//+----------------构建获取验证码参数----------------
			var timestamp = parseInt(Date.now()/1000);
			var pmAppVersion = this.store.state.pmAppVersion;
			var signKey = this.store.state.signKey;
			var a='pmAppVersion='+ pmAppVersion +'&';
			var b='timestamp='+ timestamp + '&type='+ type;
			var c='&ubPhone='+ phone +'&key='+ signKey;
			var s=a+b+c;
			var sign = this.md5(s);
			let data = {
				sign:sign,
				ubPhone:phone,//传值
				type:type,
				timestamp:timestamp,
				pmAppVersion:pmAppVersion,
			};
			//+--------------------获取注册验证码--------------------
			this.apiServer.login.getMessage(this.qs.stringify(data))
			.then(res => {
				if(res.data.code == 200){
					this.verifyCodeBtn = true;
					this.canClickTwo = false;
					this.contentTwo = this.totalTimeTwo + 's后获取'
					let clock = window.setInterval(() => {
						this.totalTimeTwo--
						this.contentTwo = this.totalTimeTwo + 's后获取'
						if (this.totalTimeTwo < 0) {
							window.clearInterval(clock)
							this.contentTwo = '获取验证码'
							this.totalTimeTwo = 60
							this.canClickTwo = true  //这里重新开启
							this.verifyCodeBtn = false;
						}
					},1000);
					
					this.$message.success('验证码发送成功');
				}
			})
			.catch(error => {
				this.$message.error(error);
			});
		},
		registerAndLogin(temp,message){
			//+----------------构建注册参数---------------
			var timestamp = parseInt(Date.now()/1000);
			let data = {
				// 'pmAppVersion':this.store.state.pmAppVersion,
				ubPhone:temp.phone,
				vcCode:temp.verify_code,
				udPwd:this.md5(this.md5(temp.password)),
				dfCode:temp.invitation ? temp.invitation : '',
				applicationType:this.store.state.applicationType,
				// 'appId':'',
				// 'sign':sign,
				// 'randomCode':timestamp,
				// 'timestamp':timestamp,
				// 'isPassenger':0,
			};
			//+-------------------请求注册----------------
			this.apiServer.login.registAndLogin(this.qs.stringify(data))
			.then(res => {
				if(res.data.code == 200){
					if(res.data.data.businessCode != 10){
						this.$message.error(res.data.data.businessMessage);
						return false;
					}
					//注册成功【保存用户信息】
					this.saveUserInfo(res);
					//用户已登录显示
					this.userInfo = JSON.parse(localStorage.getItem('user'));
					//【给出提示】
					this.$message.success(message);
					//关闭dialog
					this.registerDialog = false;
					this.fastLoginDialog = false;
					return true;
				}else{
					this.$message.error(res.message);
					return false;
				}
			})
			.catch(error => {
				this.$message.error(error);
			});
		},
		//注册
		registerByApp(temp,message){
			//+----------------构建注册参数---------------
			var timestamp = parseInt(Date.now()/1000);
			let data = {
				// 'pmAppVersion':this.store.state.pmAppVersion,
				ubPhone:temp.phone,
				vcCode:temp.verify_code,
				udPwd:this.md5(this.md5(temp.password)),
				dfCode:temp.invitation ? temp.invitation : '',
				applicationType:this.store.state.applicationType,
				// 'appId':'',
				// 'sign':sign,
				// 'randomCode':timestamp,
				// 'timestamp':timestamp,
				// 'isPassenger':0,
			};
			//+-------------------请求注册----------------
			this.apiServer.login.appRegist(this.qs.stringify(data))
			.then(res => {
				if(res.data.code == 200){
					if(res.data.data.businessCode != 10){
						this.$message.error(res.data.data.businessMessage);
						return false;
					}
					//注册成功【保存用户信息】
					this.saveUserInfo(res);
					//用户已登录显示
					this.userInfo = JSON.parse(localStorage.getItem('user'));
					//【给出提示】
					this.$message.success(message);
					//关闭dialog
					this.registerDialog = false;
					this.fastLoginDialog = false;
					return true;
				}else{
					this.$message.error(res.message);
					return false;
				}
			})
			.catch(error => {
				this.$message.error(error);
			});
		},
		//获取用户牛币
		getUserCoin(){
			if(this.userInfo){
				this.apiServer.mine.getCoin()
				.then(res => {
					if(res.data.code == 200 && res.data.data.businessCode == 10){
						this.userBalance = res.data.data.billDetails.billNum;
					}
				})
				.catch(res => {
					console.log('更新用户余额异常');
				});
			}
		},
		//获取用户中心信息
		getUserCenter(){
			//+---------------------构建参数-------------------------
			let data = {};
			//+---------------------请求用户信息--------------------
			this.apiServer.mine.getData()
			.then(res => {
				if(res.data.code == 200){
					this.userCenter = res.data.data;
					//更新用户牛币
					this.userBalance = res.data.data.totalNiubi;
				}
			})
			.catch(res => {
				console.log('获取用户中心异常');
			});
		},
		//用户信息变更
		userInfoChange(){
			//+------------信息变更
			if(this.$route.path == '/'){
				this.$router.go(0);
			}else{
				this.$router.push({path:'/'});
			}
		},
		//退出登录
		loginOut(){
			//+-------------------清空缓存数据-------------------------
			localStorage.removeItem('user');
			localStorage.removeItem('token');
      localStorage.removeItem('refreshToken');
			this.userInfo = '';
			if(this.$route.path == '/'){
				this.$router.go(0);
			}else{
				//跳转到首页
				this.$router.push({name:'index'});
			}
		},
		// 登录后功能操作
		afterLoginHandle(command){
			switch (command){
				//我的牛币
				case 'wallet':
					console.log('点击了牛币');
					break;
				//我的订阅
				case 'subscribe':
					this.$router.push({name:"mySubscribe"});
					break;
				//退出登录
				case 'login_out':
					this.loginOut();
					break;
				default:
					break;
			}
		},
    saveUserInfo(res){
      localStorage.setItem('user',JSON.stringify(res.data.data));
      localStorage.setItem('token',res.data.data.token);
      localStorage.setItem('refreshToken',res.data.data.refreshToken);
    },
	}
}
</script>

<style scoped>
	.seconedWidth{
		width: 1340px;
		height: 90px;
		margin: 0 auto;
	}
	
	.seconedWidth #nav>ul{
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	
	li>a {
		text-decoration: none;
		display: block;
		text-align: center;
		font-size: 24px;
		color: #222222;
		border-radius: 28px;
		
		font-family: PingFangSC-Semibold, PingFang SC;
		font-weight: 400;
	}
	
	#nav{
		height: 100%;
	}
	#nav ul{
		height: 100%;
		margin: 0 auto;
	}
	#nav ul>li:nth-child(1){
		width: 160px;
		margin-right: 80px;
		display: flex;
		font-size: 24px;
		justify-content: space-between;
		align-content: space-around;
		align-items: center;
		
		font-family: PingFangSC-Semibold, PingFang SC;
		font-weight: 600;
		color: #222222;
		line-height: 33px;
	}
	
	#nav li {
		min-width: 120px;
		list-style: none;
		line-height: 45px;
		margin-right: 68px;
	}
	#nav ul>li>a:hover{
		background-color: pink;
		border-radius: 1.75rem;
	}
	.active {
		background-color: #E4343C;
		color: #FFFFFF;
	}
	.hover{
		background-color: rgb(248, 209, 210);
		color: #000;
	}
	.denglu {
		display: inline-block;
		vertical-align: middle;
	}
	.denglu img {
		width: 25px;
		display: inline-block;
		/* vertical-align: 14px; */
	}
	.denglu .shuxian {
		display: inline-block;
		width: 2px;
		height: 20px;
		background: #B5B5B5;
		margin: 0 5px;
		vertical-align: text-bottom;
	}
	.zhuce:hover {
	cursor:pointer
	}
	.my-info-dialog .el-dialog__header .el-dialog__title{
		line-height: 24px;
		float: left;
		font-size: 18px;
		color: #303133;
	}
	.numberInput >>> .el-input__inner{
		padding: 0 40px;
		position: relative;
	}
	.img1 {
		position: absolute;
		top: 7px;
		left: -45px;
		z-index: 200;
		width: 25px;
		height: 25px;
	}
	.footer{
		float: right;
	}
	.edit-diog >>> .el-dialog__body{
		padding: 30px 30px 40px 0;
	}
	.edit-diog >>> .el-dialog{
		border-radius: 10px;
	}
	.step1{
		width: 80%;
		margin: 0 20px 20px 60px;
	}
	.step2{
		width: 80%;
		height: 85px;
		
		margin: 0 20px 20px 60px;
	}
	.after_login {
		margin: 0;
	}
	.wallet-balance .balance-text{
		position: relative;
	}
	.wallet-balance .balance-unit img{
		position: absolute;
		width: 20%;
		right: -1.25rem;
		top: 3.125rem;
	}
	
	/* 新改动 */
	.modal-content {
	    position: relative;
	    background-color: #fff;
	    -webkit-background-clip: padding-box;
	    background-clip: padding-box;
	    border: 1px solid #999;
	    border: 1px solid rgba(0, 0, 0, .2);
	    border-radius: 6px;
	    outline: 0;
	    -webkit-box-shadow: 0 3px 9px rgba(0, 0, 0, .5);
	    box-shadow: 0 3px 9px rgba(0, 0, 0, .5);
	}
	
	.Width_1 {
	    width: 400px;
	    position: absolute;
	    top: 50%;
	    left: 50%;
	    z-index: 3;
	    margin: auto;
	    -webkit-transform: translate(-50%, -50%) !important;
	    -moz-transform: translate(-50%, -50%) !important;
	    -ms-transform: translate(-50%, -50%) !important;
	    -o-transform: translate(-50%, -50%) !important;
	    transform: translate(-50%, -50%) !important;
	}
	
	.el-dialog>.#banner {
		height: 370px;
		border-radius: 5px;
	}
	.modal-title {
	    padding: 25px 15px 0px;
	}
	.modal-title>h1 {
	    font-size: 24px;
	    font-weight: 500;
	    display: inline-block;
	    float: left;
	}
	.modal-title #moddel {
	    color: #E4343C;
	    font-size: 14px;
	    float: right;
	    margin-top: 14px;
	}
	.modal-body {
	    position: relative;
	    padding: 15px;
	}
	.form-group {
	    position: relative;
	    margin-bottom: 0.9375rem;
	}
	.text-center {
	    text-align: center;
	}
	.form-group ul {
	    padding: 15px 0;
	    position: relative;
	    z-index: 9;
	}
	
	.point-1 {
	    background-image: url("../../assets/img/icon_light.4353d81.png");
	    background-position: 0 -367px;
	    background-size: 32px 544px;
	    width: 26px;height: 33px;position: absolute;cursor: pointer;background-repeat: no-repeat;
	  }
	  .point-2 {
	    background-image: url("../../assets/img/icon_light.4353d81.png");
	    background-position: 0 -403px;
	    background-size: 32px 544px;
	    width: 26px;height: 33px;position: absolute;cursor: pointer;background-repeat: no-repeat;
	  }
	
	  .point-3 {
	    background-image: url("../../assets/img/icon_light.4353d81.png");
	    background-position: 0 -439px;
	    background-size: 32px 544px;
	    width: 26px;height: 33px;position: absolute;cursor: pointer;background-repeat: no-repeat;
	  }
	
	  .checkSuccessItem{
	    margin-right: 5px;
	    width: 17px;
	    height: 12px;
	    vertical-align: middle;
	    background-image: url("../../assets/img/icon_light.4353d81.png");
	    background-position: 0 -67px;
	    background-size: 32px 544px;
	
	  }

	  .refreshItem{
	    position: absolute;
	    right: 0;
	    top: 0;
	    max-width: 68px;
	    z-index: 2;
	    background-image: url("../../assets/img/icon_light.4353d81.png");
	    background-position: 0 -266px;
	    background-size: 32px 544px;
	    float: right;
	    width: 30px;
	    height: 30px;
	    margin-left: 4px;
	    cursor: pointer;
	  }
	
	  .revolveItem{
	    background-image: url("../../assets/img/icon_light.4353d81.png");
	    background-position: 0 -332px;
	    background-size: 32px 544px;
	    animation: loading .8s linear infinite;
	    width: 32px;
	    height: 32px;
	    background-repeat: no-repeat;
	    text-align: center;
	  }
</style>


// WEBPACK FOOTER //
// src/components/common/header.vue